
import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "./api/baseApi";
import authReducer from "./slices/authSlice"; // <-- make sure this path matches your project

// optional helper to enable RTK Query listeners (refetchOnFocus, refetchOnReconnect)
import { setupListeners } from "@reduxjs/toolkit/query";

// Middleware to clear client-side PDF/Report cache whenever any database mutation succeeds
const cacheInvalidatorMiddleware = (store) => (next) => (action) => {
  if (action.type && action.type.endsWith('/executeMutation/fulfilled')) {
    console.log('[store] Database mutation fulfilled. Clearing report cache to prevent stale data...');
    import('../../utils/reportCache')
      .then(({ clearReportCache }) => {
        clearReportCache().catch(err => console.error('[store] Clear cache error:', err));
      })
      .catch(err => console.error('[store] Import reportCache error:', err));
  }
  return next(action);
};

const store = configureStore({
  reducer: {
    // auth slice (persisted to localStorage inside the slice reducer)
    auth: authReducer,

    // RTK Query generated reducer
    [baseApi.reducerPath]: baseApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling, and other RTK Query features
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, cacheInvalidatorMiddleware),
  devTools: process.env.NODE_ENV !== "production",
});

// enable optional listeners for refetchOnFocus/refetchOnReconnect
setupListeners(store.dispatch);

export default store;

